<div class="item-page-field" *ngIf="hasContent">
  <ds-metadata-field-wrapper [label]="label | translate">
    <div class="original-publication">
      <span class="original-publication-citation dont-break-out" *ngIf="citation">{{ citation }}</span>
      <a class="original-publication-reference dont-break-out"
         *ngIf="reference"
         [href]="reference"
         target="_blank"
         rel="noopener noreferrer">{{ reference }}</a>
    </div>
  </ds-metadata-field-wrapper>
</div>
